import {Box, Typography} from '@mui/material';

import {empionGreen} from '../../../../../layouts/theme/EmpionColors';

interface Props {
  label: string;
  value: string;
}

const META_LABEL_SX = {color: empionGreen[100], fontSize: '12px', lineHeight: 1.3} as const;
const META_VALUE_SX = {color: empionGreen[700], fontSize: '14px', fontWeight: 600, lineHeight: 1.3} as const;

export const MatchMetaItem = ({label, value}: Props) => (
  <Box sx={{minWidth: 0}}>
    <Typography sx={META_LABEL_SX}>{label}</Typography>
    <Typography sx={META_VALUE_SX} noWrap>
      {value}
    </Typography>
  </Box>
);
